
<template>
  <div class="top">
    <div class="toolInfo">
      <div class="back">
        <el-button size="mini" @click="back" type='primary' plain class="iconfont icon-fanhui1"></el-button>
      </div>
      <div :class="['tooleName', { mobileFontSize: $isMobile }]">{{ toolInfo.name }}
      </div>
      <div :class="['toolText', { mobileFontSize: $isMobile }]">{{ toolInfo.desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toolInfo: {},
      sort: null
    }
  },
  props: ['toolSort'],
  created() {
    this.sort = parseInt(this.toolSort)
    this.getToolInfo()

  },
  methods: {
    //获取工具详情
    async getToolInfo() {
      let res = await this.$axios.post(this.$serviceAPI.findToolBySort, {
        sort: this.sort
      })
      this.toolInfo = res.data.data
    },
    back() {
      this.$router.replace({path:"/indexSub"});
    }
  }
}
</script>

<style scoped="scoped">
.top {
  width: 100%;
}

.toolInfo {
  flex: 5;
  border-radius: 0.625rem;
  background: whitesmoke;
  padding: .7rem;
  font-size: 14px;
}

.tooleName {
  font-weight: 600;
  font-size: 14px;
  line-height: 32px;
  margin-left: 3rem;
}

.toolText {
  margin-top: .8rem;
  color: #999999;
  font-size: 13px;
}

.back {
  float: left;
}</style>



// WEBPACK FOOTER //
// src/components/subComponents/top.vue